// extracted by mini-css-extract-plugin
export default {"highlight":"ErrorMessage_highlight__HuQ-u","shake":"ErrorMessage_shake__+NusV"};